import React from 'react';
import DHRouter from '~/components/atom/DHRouter';

import withErrorBoundary from '~/hocs/withErrorBoundary';
import { RouteComponentProps, useLocation } from '@gatsbyjs/reach-router';
import NotFound from '~/components/page/404';
import BndlLoading from '~/components/atom/BndlLoading';
import useApp from '~/hooks/useApp';
import ValueReportDetails from './components/ValueReportDetails';
import ValueReportList from './components/ValueReportList';

type Props = RouteComponentProps;

export const WAARDERAPPORT_URL_PREFIX = 'www.mijnwaarderapport.nl/c/';

const ValueReport: React.FCC<Props> = withErrorBoundary<Props>(() => {
  const location = useLocation();
  const { app, loading } = useApp('AppStatus_ValuationReport');

  if (loading) return <BndlLoading />;
  if (!app?.appStatus.enabled) return <NotFound />;

  return (
    <>
      <DHRouter>
        <ValueReportList path="/" location={location} />
        <ValueReportDetails path="/:reportId/*" location={location} />
      </DHRouter>
    </>
  );
});

export default ValueReport;
